'use strict';

class SubImages {

    constructor() {
        this.url = 'https://report.tal-gr.com/storage/picture';
        this.noImage = '/assets/images/no-image.jpg';
    }

    loadSubImages(imgPath) {

        // 画像が無い場合はカードを表示しない
        for (let i = 1; i <= 6; i++) {

            let img = new Image();
            let $imgContainer = $('#subImage' + i);
            let $itemImg = $imgContainer.find('img');

            img.onload = () => {

                $itemImg.attr('src', img.src);
                $imgContainer.addClass('show');

            }

            img.onerror = () => {

                $itemImg.attr('src', this.noImage);
            }

            img.src = this.url + imgPath + 'Sub' + i + '.jpg';

        }

    }

}

export default SubImages;



